import { BillingTotals, CartItemAction, Currency } from "../../../index";

interface PriceConstructorProps {
	amount: number;
	currency: Currency;
}

class Price {
	constructor(private _: PriceConstructorProps) {}

	get amount() {
		return this._.amount;
	}

	get currency() {
		return this._.currency;
	}

	static fromJson(json: any) {
		return new Price({
			amount: json?.amount || 0,
			currency: json?.currency || Currency.defaultValue,
		});
	}

	static fromPaddleItemPrice(price: any) {
		const unitPrice = price?.unitPrice || price?.unit_price;
		return new Price({
			amount: BillingTotals.fromPaddleAmount(unitPrice?.amount),
			currency:
				unitPrice.currencyCode ||
				unitPrice.currency_code ||
				Currency.defaultValue,
		});
	}

	toPaddlePrice() {
		return `${this.currency}:${this.amount}`;
	}

	get isFree() {
		return this.amount === 0;
	}

	toJson() {
		const res = { amount: this.amount, currency: this.currency } as any;
		return res;
	}

	display(showFree: boolean, showPrefix: boolean) {
		if (this.isFree && showFree) {
			return "Free";
		}
		const amount = parseFloat(String(this.amount));
		const symbol = Currency.display(this.currency);
		if (amount < 0) {
			return `${CartItemAction.prefix(
				CartItemAction.REMOVE
			)}${symbol}${Math.abs(amount)}`;
		}
		const prefix = showPrefix ? CartItemAction.prefix(CartItemAction.ADD) : "";
		return `${prefix}${symbol}${amount}`;
	}

	withAmount(amount: number) {
		return new Price({
			amount,
			currency: this.currency,
		});
	}

	merge(other: Price) {
		if (this.currency !== other.currency) {
			throw new Error("Cannot merge billing prices with different currencies");
		}
		return new Price({
			amount: this.amount + other.amount,
			currency: this.currency,
		});
	}

	multiply(quantity: number) {
		return new Price({
			amount: this.amount * quantity,
			currency: this.currency,
		});
	}
}

export { Price };
